import React, { useEffect, useState } from 'react';
import { Drawer, Box } from '@mui/material';
import SideNav from '../../SideNav';
import { useIsDesktop } from '../../../hooks';

const DrawerExtend = () => {
    const isDesktop = useIsDesktop();
    const [drawerHeight, setDrawerHeight] = useState(window.innerHeight);

    const updateDrawerHeight = () => {
        const documentHeight = Math.max(
            document.body.scrollHeight,
            document.documentElement.scrollHeight,
            document.body.offsetHeight,
            document.documentElement.offsetHeight,
            document.body.clientHeight,
            document.documentElement.clientHeight
        );

        setDrawerHeight(documentHeight);
    };

    useEffect(() => {
        updateDrawerHeight();
        window.addEventListener('scroll', updateDrawerHeight);
        return () => {
            window.removeEventListener('scroll', updateDrawerHeight);
        };
    }, []);

    // Desktop nav renders only at/above the 800px breakpoint (US 14628). Below
    // that, the hamburger/mobile drawer in NavBar takes over — gating by render
    // (not a `display` breakpoint) keeps this aligned with `useIsDesktop` and
    // avoids the 768–799px gap where the old `md` switch showed a restricted
    // menu with no hamburger.
    if (!isDesktop) {
        return null;
    }

    return (
        <Drawer
            variant="permanent"
            sx={{
                display: 'block',
                zIndex: 1,
                [`& .MuiDrawer-paper`]: {
                    width:  { md: '16vw', lg: '12vw' },
                    boxSizing: 'border-box', 
                    zIndex: 1, 
                    position: 'absolute', 
                    height: drawerHeight, // Dynamically set height
                    overflow: 'auto', 
                },
            }}
        >
            <SideNav />
        </Drawer>
    );
};

export default DrawerExtend;